// // src/router.js
// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// import Header from "./components/Header";
// import Home from "./pages/public/Home";
// import AboutPage from "./pages/public/AboutPage";
// import BookingPage from "./pages/public/BookingPage";
// import SelectStaffPage from "./pages/public/SelectStaffPage";
// import SelectTimePage from "./pages/public/SelectTimePage";
// import ConfirmPage from "./pages/public/ConfirmPage";
// import BookingConfirmedPage from "./pages/public/BookingConfirmedPage";
// import WeeklyCalendar from "./pages/public/WeeklyCalendar";

// export default function AppRouter() {
//   return (
//     <>
//       <Header />
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/about" element={<AboutPage />} />
//         <Route path="/booking" element={<BookingPage />} />
//         <Route path="/select-staff" element={<SelectStaffPage />} />
//         <Route path="/select-time" element={<SelectTimePage />} />
//         <Route path="/confirm" element={<ConfirmPage />} />
//         <Route path="/booking-confirmed" element={<BookingConfirmedPage />} />
//         <Route path="/admin/calendar" element={<WeeklyCalendar />} />
//       </Routes>
//       </>
//   );
// }

// src/router.js
import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import Header from "./components/Header";
import Home from "./pages/public/Home";
import AboutPage from "./pages/public/AboutPage";
import BookingPage from "./pages/public/BookingPage";
import SelectStaffPage from "./pages/public/SelectStaffPage";
import SelectTimePage from "./pages/public/SelectTimePage";
import ConfirmPage from "./pages/public/ConfirmPage";
import BookingConfirmedPage from "./pages/public/BookingConfirmedPage";
import WeeklyCalendar from "./pages/public/WeeklyCalendar";

export default function AppRouter() {
  const location = useLocation();

  // hide header on any /admin route
  const hideHeader = location.pathname.startsWith("/admin");

  return (
    <>
      {!hideHeader && <Header />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/select-staff" element={<SelectStaffPage />} />
        <Route path="/select-time" element={<SelectTimePage />} />
        <Route path="/confirm" element={<ConfirmPage />} />
        <Route path="/booking-confirmed" element={<BookingConfirmedPage />} />
        <Route path="/admin/calendar" element={<WeeklyCalendar />} />
      </Routes>
    </>
  );
}
